const MONTH_NAMES = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export const PERIOD_TYPES = {
  MONTH: "month",
  QUARTER: "quarter",
  HALF_YEAR: "halfYear",
  YEAR: "year",
};

export const PERIOD_TYPE_LABELS = {
  [PERIOD_TYPES.MONTH]: "Месяц",
  [PERIOD_TYPES.QUARTER]: "Квартал",
  [PERIOD_TYPES.HALF_YEAR]: "Полугодие",
  [PERIOD_TYPES.YEAR]: "Год",
};

export const formatDateISO = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const startOfDay = (date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

const getToday = () => startOfDay(new Date());

export const getDefaultAnchorDate = () => new Date();

export const getPeriodRange = (periodType, anchorDate) => {
  const today = getToday();
  const anchor = startOfDay(anchorDate);
  const year = anchor.getFullYear();
  const month = anchor.getMonth();

  let dateFrom;
  let dateTo;

  switch (periodType) {
    case PERIOD_TYPES.MONTH:
      dateFrom = new Date(year, month, 1);
      dateTo = new Date(year, month + 1, 0);
      break;
    case PERIOD_TYPES.QUARTER: {
      const quarter = Math.floor(month / 3);
      dateFrom = new Date(year, quarter * 3, 1);
      dateTo = new Date(year, quarter * 3 + 3, 0);
      break;
    }
    case PERIOD_TYPES.HALF_YEAR: {
      const half = month < 6 ? 0 : 1;
      dateFrom = new Date(year, half * 6, 1);
      dateTo = new Date(year, half * 6 + 6, 0);
      break;
    }
    case PERIOD_TYPES.YEAR:
    default:
      dateFrom = new Date(year, 0, 1);
      dateTo = new Date(year, 11, 31);
      break;
  }

  if (dateTo > today) {
    dateTo = today;
  }

  return {
    dateFrom: formatDateISO(dateFrom),
    dateTo: formatDateISO(dateTo),
  };
};

export const getPeriodLabel = (periodType, anchorDate) => {
  const year = anchorDate.getFullYear();
  const month = anchorDate.getMonth();

  switch (periodType) {
    case PERIOD_TYPES.MONTH:
      return `${MONTH_NAMES[month]} ${year}`;
    case PERIOD_TYPES.QUARTER: {
      const quarter = Math.floor(month / 3) + 1;
      return `${quarter} квартал ${year}`;
    }
    case PERIOD_TYPES.HALF_YEAR:
      return month < 6 ? `1 полугодие ${year}` : `2 полугодие ${year}`;
    case PERIOD_TYPES.YEAR:
    default:
      return `${year} год`;
  }
};

export const shiftAnchorDate = (periodType, anchorDate, direction) => {
  const next = new Date(anchorDate);

  switch (periodType) {
    case PERIOD_TYPES.MONTH:
      next.setMonth(next.getMonth() + direction);
      break;
    case PERIOD_TYPES.QUARTER:
      next.setMonth(next.getMonth() + direction * 3);
      break;
    case PERIOD_TYPES.HALF_YEAR:
      next.setMonth(next.getMonth() + direction * 6);
      break;
    case PERIOD_TYPES.YEAR:
    default:
      next.setFullYear(next.getFullYear() + direction);
      break;
  }

  return next;
};

export const canShiftForward = (periodType, anchorDate) => {
  const nextAnchor = shiftAnchorDate(periodType, anchorDate, 1);
  const { dateFrom } = getPeriodRange(periodType, nextAnchor);
  const periodStart = startOfDay(new Date(dateFrom));
  return periodStart <= getToday();
};

export const formatPeriodRange = (dateFrom, dateTo) => {
  const format = (iso) => {
    const [year, month, day] = iso.split("-");
    return `${day}.${month}.${year}`;
  };
  return `${format(dateFrom)} — ${format(dateTo)}`;
};
